import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import './PhotosTab.css';

const PHOTO_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'food', label: 'Food' },
  { value: 'symptoms', label: 'Symptoms' },
  { value: 'progress', label: 'Progress' },
];

export default function PhotosTab({ clientId }) {
  const [photos, setPhotos] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  useEffect(() => {
    loadPhotos();
  }, [clientId]);

  async function loadPhotos() {
    setLoading(true);
    const { data } = await supabase
      .from('photos')
      .select('*')
      .eq('client_id', clientId)
      .order('date', { ascending: false });

    setPhotos(data || []);
    setLoading(false);
  }

  const filtered = filter === 'all' ? photos : photos.filter((p) => p.category === filter);

  if (loading) {
    return <div className="tab-loading">Loading photos...</div>;
  }

  return (
    <div className="photos-tab">
      {/* Filter chips */}
      <div className="photos-filters">
        {PHOTO_FILTERS.map((f) => (
          <button
            key={f.value}
            className={`photos-filter-chip ${filter === f.value ? 'chip-active' : ''}`}
            onClick={() => setFilter(f.value)}
          >
            {f.label}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="protocol-empty">
          <p>No photos yet.</p>
          <p style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)' }}>
            Photos will appear here when your client uploads them.
          </p>
        </div>
      ) : (
        <div className="photos-grid">
          {filtered.map((photo) => (
            <div
              key={photo.id}
              className="photo-thumb"
              onClick={() => setSelectedPhoto(photo)}
            >
              <img src={photo.photo_url} alt={photo.caption || photo.category} />
              <div className="photo-thumb-overlay">
                <span className={`photo-cat-badge cat-${photo.category}`}>
                  {photo.category}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Full-size viewer */}
      {selectedPhoto && (
        <div className="photo-viewer" onClick={() => setSelectedPhoto(null)}>
          <div className="photo-viewer-content" onClick={(e) => e.stopPropagation()}>
            <button className="photo-viewer-close" onClick={() => setSelectedPhoto(null)}>✕</button>
            <img src={selectedPhoto.photo_url} alt={selectedPhoto.caption || ''} className="photo-viewer-img" />
            <div className="photo-viewer-info">
              <span className={`photo-cat-badge cat-${selectedPhoto.category}`}>
                {selectedPhoto.category}
              </span>
              <span className="photo-viewer-date">
                {new Date(selectedPhoto.date + 'T12:00:00').toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })}
              </span>
            </div>
            {selectedPhoto.caption && (
              <p className="photo-viewer-caption">{selectedPhoto.caption}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
